import {
  AnalyticsConfigurationKeys,
  ANALYTICS_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/analytics-rules';
import { UserRole } from '@epicuro-next/data/users';

import { AnalyticsSignalREvent } from '../models/signalr-events';

export const ANALYTICS_ENTITIES_STATE_KEY = 'analytics';

export const ROLES_CAN_SEE_ANALYTICS = [
  UserRole.Administrator,
  UserRole.SalesRepresentative,
];

export const ANALYTICS_ROLES_CONFIG = {
  namespace: ANALYTICS_NAMESPACE,
  featureName: AnalyticsConfigurationKeys.EnableListAnalytics,
  defaultValue: [UserRole.Administrator],
};

export const ANALYTICS_BASKET_INSIGHT_CONFIG = {
  namespace: ANALYTICS_NAMESPACE,
  featureName: AnalyticsConfigurationKeys.EnableListAnalyticsBasketInsight,
  defaultValue: false,
};

export const ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG = {
  namespace: ANALYTICS_NAMESPACE,
  featureName:
    AnalyticsConfigurationKeys.AnalyticsListBasketInsightDefaultSorting,
  defaultValue: 'Revenue',
};

export const BASKET_INSIGHTS_PAGE_SIZE = 10;

export const analyticsListEvents = [
  AnalyticsSignalREvent.ListAddedReportEvent,
  AnalyticsSignalREvent.ListOpenedReportEvent,
  AnalyticsSignalREvent.ListPlacedReportEvent,
];
